export default __webpack_public_path__ + "images/bgflt5.8a195ff.jpg";